import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";
import {PushNotificationsConfig} from "../persistence-layer/models/push-notifications-config.model";

angular
  .module('bringoz.admin.deliveries')
  .factory('$delivery', DeliveryObjectFactory);

/* @ngInject */
function DeliveryObjectFactory($bringozFactory: $bringozFactory,
                               DeliveriesAPI: BringozApi,
                               Deliveries_DS: DataStoreConfig,
                               Deliveries_PN: PushNotificationsConfig) {

  function $delivery(id: string) {
    return $bringozFactory(id, DeliveriesAPI, Deliveries_DS, Deliveries_PN)
  }

  return $delivery;
}
